export interface Country {
  code: string;
  name: string;
  flag: string;
}

export const ALL_COUNTRIES: Country[] = [
  { code: 'USA', name: 'Estados Unidos', flag: '🇺🇸' },
  { code: 'PER', name: 'Perú', flag: '🇵🇪' },
];

function resolveActiveCountries(): Country[] {
  const raw = process.env.VUE_APP_DIAGNOSTIC_SUPPORTED_COUNTRIES || 'USA';
  const codes = raw
    .split(',')
    .map((c) => c.trim().toUpperCase())
    .filter((c) => c.length > 0);

  return codes
    .map((code) => ALL_COUNTRIES.find((c) => c.code === code))
    .filter((c): c is Country => c !== undefined);
}

export const SUPPORTED_COUNTRIES: Country[] = resolveActiveCountries();

export const DIAGNOSTIC_LEVELS = {
  INITIAL: 'INITIAL',
  INTERMEDIATE: 'INTERMEDIATE',
  ADVANCED: 'ADVANCED',
} as const;

export type DiagnosticLevel = typeof DIAGNOSTIC_LEVELS[keyof typeof DIAGNOSTIC_LEVELS];

export interface Grade {
  value: number;
  text: string;
}

export const GRADES: Grade[] = [
  { value: 1, text: '1°' },
  { value: 2, text: '2°' },
  { value: 3, text: '3°' },
  { value: 4, text: '4°' },
  { value: 5, text: '5°' },
  { value: 6, text: '6°' },
  { value: 7, text: '7°' },
  { value: 8, text: '8°' },
  { value: 9, text: '9°' },
  { value: 10, text: '10°' },
  { value: 11, text: '11°' },
  { value: 12, text: '12°' },
];

export const ANSWER_LETTERS = ['A', 'B', 'C', 'D'] as const;

export type AnswerLetter = typeof ANSWER_LETTERS[number];

export function getCountryByCode(code: string): Country | undefined {
  return ALL_COUNTRIES.find((c) => c.code === code);
}

export function getAnswerLetter(index: number): AnswerLetter {
  return ANSWER_LETTERS[index] || 'A';
}

export function getAnswerLetterByItem(item: number): AnswerLetter {
  if (item >= 1 && item <= ANSWER_LETTERS.length) {
    return ANSWER_LETTERS[item - 1];
  }

  return 'A';
}
